import { useState } from "react";
import { faqData } from "@/mocks/homeData";

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 text-balance leading-tight">
              关于<span className="text-primary-500">51漫画</span>
              <br />
              你想知道的都在这里
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-md">
              整理了用户最常问的问题，帮助你快速了解51漫画平台的使用方法和特色功能。
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-accent-500 rounded-3xl p-6 md:p-8 text-background-50">
              <div className="flex items-center justify-between mb-6">
                <span className="text-xs font-medium bg-background-50/20 px-3 py-1 rounded-full">
                  用户答疑
                </span>
                <div className="flex gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/60"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/60"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/60"></span>
                </div>
              </div>
              <div className="space-y-3">
                {faqData.map((faq) => (
                  <div
                    key={faq.id}
                    className="border border-background-50/20 rounded-2xl overflow-hidden"
                  >
                    <button
                      onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                      className="w-full flex items-center justify-between px-4 md:px-5 py-3.5 text-left hover:bg-background-50/5 transition-colors duration-200"
                    >
                      <span className="font-medium text-sm pr-4">{faq.question}</span>
                      <i
                        className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform duration-300 flex-shrink-0 ${
                          openId === faq.id ? "rotate-180" : ""
                        }`}
                      ></i>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        openId === faq.id ? "max-h-96 pb-4 px-4 md:px-5" : "max-h-0"
                      }`}
                    >
                      <p className="text-sm text-background-50/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}